import Controller from 'controllers/controller';
import jQuery from 'jquery';

class LazySvgController extends Controller {
    constructor(app, placeholder) {
        super(app);
        
        this.fallback = APP_ROOT + 'site/templates/svg/question-mark.svg';
        this.placeholder = placeholder;

        this.placeholder.classList.add('loading');
        
        // When Document is ready, fetch the source
        jQuery(this.getSource);
    }
    
    getSourceUrl() {
        return this.placeholder.getAttribute('data-src') || this.fallback;
    }
    
    getClassAttribute() {
        return this.placeholder.getAttribute('data-class') || '';
    }
    
    getSource() {
        jQuery.get({
            url: this.getSourceUrl(),
            dataType: 'text' // Fetch as plain text
        }).then(response => {
            // Set innerHTML of placeholder (faster processing of SVG this way, too)
            this.placeholder.innerHTML = response;
            
            let svg = this.placeholder.children[0],
                parent = this.placeholder.parentElement;
            
            // Carry class attribute over
            svg.setAttribute('class', this.getClassAttribute());

            // Move SVG outside of placeholder, to a new position just before the placeholder in the parent
            parent.insertBefore(svg, this.placeholder);
            
            // Remove the placeholder
            parent.removeChild(this.placeholder);
        })
    }
}

export default LazySvgController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/components/lazy-svg.js